export default class TransferHelper {

  static createRequestData(standardOrder, customOrderId, orderPriority, analyses, additionalInfos) {

    let mappedAdditionalInfos = [];
    for (const additionalInfo of additionalInfos) {
      // Only send prompts of type KWEB, because these are
      // the only ones, which are visible to the web user 
      // and can be set by the web user through the UI.
      if (additionalInfo.REPT_KLASSE === "KWEB") {
        const mappedAdditionalInfo = {
          layoutIndex: additionalInfo.LAYO_ID,
          layoutVersion: additionalInfo.LAYO_VERSION,
          infoIndex: additionalInfo.LAPR_ID,
          infoPrompt: additionalInfo.PROMPT,
          infoText: additionalInfo.VALUE ?? ""
        }
        mappedAdditionalInfos.push(mappedAdditionalInfo);
      }
    }

    let mappedSamples = [];
    for (const analysis of analyses) {
      if (analysis.checked === true) {
        const mappedSample = {
          STANDARDPROBE: {
            standardauftragProbeId: analysis.standardauftragProbeId
          }
        }
        mappedSamples.push(mappedSample);
      }
    }

    let mappedOrder = {
      AUFTRAG: {
        standardauftragId: standardOrder.standardauftragId,
        zusatz1: customOrderId,
        zusatz2: orderPriority
      },
      AUFTRAGSZUSATZINFORMATION: {
        felder: mappedAdditionalInfos
      },
      PROBEN: mappedSamples
    };

    return mappedOrder;
  }

  static presetAdditionalInfosByRequestData(additionalInfosToPreset, requestData) {
    if (requestData) {
      for (let additionalInfo of requestData["AUFTRAGSZUSATZINFORMATION"]["felder"]) {
        const layoId = additionalInfo["layoutIndex"];
        const layoVersion = additionalInfo["layoutVersion"];
        const laprId = additionalInfo["infoIndex"];
        const value = additionalInfo["infoText"];
        if (additionalInfosToPreset) {
          for (let additionalInfoToPreset of additionalInfosToPreset) {
            this.applyAdditionalInfoValue(additionalInfoToPreset, layoId, layoVersion, laprId, value);
          }
        }
      }
    }
  }

  static presetAdditionalInfosByKey(additionalInfosToPreset, layoId, layoVersion, laprId, value) {
    if (additionalInfosToPreset) {
      for (let additionalInfoToPreset of additionalInfosToPreset) {
        this.applyAdditionalInfoValue(additionalInfoToPreset, layoId, layoVersion, laprId, value);
      }
    }
  }

  static applyAdditionalInfoValue(sourceAdditionalInfo, targetLayoId, targetLayoVersion, targetLaprId, targetValue) {
    // Only apply previous values if layout and version match exactly
    if (sourceAdditionalInfo["LAYO_ID"] === targetLayoId &&
        sourceAdditionalInfo["LAYO_VERSION"] === targetLayoVersion &&
        sourceAdditionalInfo["LAPR_ID"] === targetLaprId) {
      sourceAdditionalInfo["VALUE"] = targetValue;
    }
    else {
      // The field value as a reference used for a domain parameter
      // This feature works only for character fields
      if (sourceAdditionalInfo["KE_DATENTYP"] === "C" &&
          sourceAdditionalInfo["DOMA_ID"] !== null && 
          sourceAdditionalInfo["BEZUG"] !== null &&
          sourceAdditionalInfo["BEZUG"].indexOf(targetLaprId) !== -1) {
        const references = sourceAdditionalInfo["BEZUG"].split(",");
        for (let i = 0; i < references.length; i++) {
          const reference = parseInt(references[i]);
          if (reference === targetLaprId) {
            const key = "DOMAIN_PARAM_" + (i+1);
            // Set the referenced field value as the domain parameter of the other field
            sourceAdditionalInfo[key] = targetValue;
            // If a domain parameter changes, the corresponding field must be cleared,
            //  because the previously entered value may be invalid
            sourceAdditionalInfo["VALUE"] = null;
          }
        }
      }
    }
  }

  static presetAnalysesFromRequestData(analysesToPreset, requestData) {
    if (requestData) {
      for (let sample of requestData["PROBEN"]) {
        const id = sample["STANDARDPROBE"].standardauftragProbeId;
        if (analysesToPreset) {
          for (let analysisToPreset of analysesToPreset) {
            if (analysisToPreset["standardauftragProbeId"] === id) {
              analysisToPreset["checked"] = true;
            }
          }
        }
      }
    }
  }
}
